if (!global.regeneratorRuntime) {
  // eslint-disable-next-line global-require
  global.regeneratorRuntime = require('regenerator-runtime')
}

// eslint-disable-next-line global-require
require('source-map-support/register')
